/**
 * routePrefetch.js
 *
 * Intent-based prefetch for the highest-traffic routes. When a visitor
 * hovers (or touches) an internal link, we quietly warm that page's
 * code-split chunk so the actual click feels near-instant.
 *
 * We only map the shared, heavily-used chunks (pillars, the journey
 * guides, key lifecycle pages). Everything else is a no-op and simply
 * loads on click as before. The import() specifiers MUST match the ones
 * in App.js so webpack points at the same chunk.
 */

const loaded = new Set();

const PILLAR_PATHS = new Set([
  '/swimming-pools', '/decking', '/landscaping', '/verandahs-pergolas',
  '/renovations', '/building-a-new-home', '/knockdown-rebuild',
  '/choosing-land', '/changing-builders', '/property-development',
  '/sheds-garages', '/interior-design', '/home-design',
]);

const RULES = [
  { key: 'pillar',    test: (p) => PILLAR_PATHS.has(p),                                    load: () => import('./pages/BuildingTypePage') },
  { key: 'improveHub', test: (p) => p === '/home-improvement',                              load: () => import('./pages/supporting/HomeImprovementHub') },
  { key: 'cost',      test: (p) => /^\/(swimming-pools|decking|landscaping|verandahs-pergolas)\/costs$/.test(p), load: () => import('./pages/supporting/ImprovementCostGuide') },
  { key: 'choose',    test: (p) => /^\/(swimming-pools|decking|verandahs-pergolas)\/choosing-a-builder$/.test(p) || p === '/landscaping/choosing-a-landscaper', load: () => import('./pages/supporting/ImprovementChoosingGuide') },
  { key: 'plan',      test: (p) => /^\/(swimming-pools|decking|landscaping|verandahs-pergolas)\/planning$/.test(p), load: () => import('./pages/supporting/ImprovementPlanningGuide') },
  { key: 'fhb',       test: (p) => p === '/first-home-buyer-adelaide',                      load: () => import('./pages/FirstHomeBuyerPage') },
  { key: 'hnl',       test: (p) => p === '/house-and-land-adelaide',                        load: () => import('./pages/packages/PackagesHubPage') },
  { key: 'home',      test: (p) => p === '/',                                               load: () => import('./pages/HomePage') },
];

export function prefetchFor(pathname) {
  if (!pathname) return;
  for (const rule of RULES) {
    if (loaded.has(rule.key)) continue;
    let match = false;
    try { match = rule.test(pathname); } catch { match = false; }
    if (match) {
      loaded.add(rule.key);
      try { rule.load(); } catch { /* ignore prefetch failures */ }
      return;
    }
  }
}
